import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Gift } from "lucide-react";

export default function ChecklistRewardsAdmin() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/checklist-rewards").then((r) => setData(r.data)).catch(() => setData(false)); }, []);
  if (!data) return null;
  return (
    <section className="rounded-2xl border border-slate-800 bg-[#0B0D12] p-4" data-testid="checklist-rewards-admin">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-3">
        <div className="flex items-center gap-2"><Gift className="w-5 h-5 text-emerald-300" /><div><p className="font-semibold">Checklist rewards</p><p className="text-xs text-slate-400">$10 ride credits granted when members finish Getting Started.</p></div></div>
        <p className="text-xs text-slate-400">Granted <b className="font-mono text-slate-100" data-testid="rewards-count">{data.count}</b> · Total <b className="font-mono text-emerald-300" data-testid="rewards-total">${data.total.toFixed(2)}</b></p>
      </div>
      {data.items.length === 0 ? <p className="text-xs text-slate-500" data-testid="rewards-empty">No rewards granted yet.</p> : (
        <ul className="space-y-1 text-xs">{data.items.slice(0, 20).map((r) => <li key={r.reward_id} className="flex gap-3 bg-[#0f1219] rounded-lg px-3 py-2" data-testid={`reward-${r.reward_id}`}><span className="flex-1 truncate">{r.name || r.email} <span className="text-slate-500">· {r.account_type}</span></span><span className="font-mono text-emerald-300">${r.amount.toFixed(0)}</span><span className="text-slate-500">{new Date(r.created_at).toLocaleDateString()}</span></li>)}</ul>
      )}
    </section>
  );
}
